const STORAGE_KEY = 'twm_report_access_tokens';
const VIEWER_UNLOCK_KEY = 'twm_report_viewer_unlock_until';
const DEFAULT_TOKEN_TTL_MS = 30 * 60 * 1000;
const DEFAULT_UNLOCK_TTL_MS = 30 * 60 * 1000;

type TokenStore = Record<string, number>;

const parseStore = (): TokenStore => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as TokenStore;
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  } catch {
    return {};
  }
};

const saveStore = (store: TokenStore) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
};

const generateToken = () => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};

export const createReportAccessToken = (ttlMs: number = DEFAULT_TOKEN_TTL_MS): string => {
  const token = generateToken();
  const store = parseStore();
  const expiresAt = Date.now() + ttlMs;
  store[token] = expiresAt;
  saveStore(store);
  return token;
};

export const hasValidReportAccessToken = (token: string): boolean => {
  if (!token) return false;

  const store = parseStore();
  const expiresAt = store[token];
  if (!expiresAt) return false;

  if (Date.now() > expiresAt) {
    delete store[token];
    saveStore(store);
    return false;
  }

  return true;
};

export const unlockReportViewer = (ttlMs: number = DEFAULT_UNLOCK_TTL_MS) => {
  const expiresAt = Date.now() + ttlMs;
  localStorage.setItem(VIEWER_UNLOCK_KEY, String(expiresAt));
};

export const hasViewerUnlock = (): boolean => {
  const raw = localStorage.getItem(VIEWER_UNLOCK_KEY);
  if (!raw) return false;

  const expiresAt = Number(raw);
  if (!Number.isFinite(expiresAt)) return false;
  return Date.now() <= expiresAt;
};

